AFRAME.registerComponent("navigate-back", {
  events: {
    click: function () {
      window.history.back();
    },
  },
});
